import React, { useEffect, useState } from 'react'
import reactDom from 'react-dom';
import { GetMonthNameByNumber } from '../../Helper/GetMonthNameByNumber';
import { Consolidado } from './Consolidado';
import { Region } from './Region';
import { Sucursal } from './Sucursal';

export const Grafica = ({ data, ejercicio, mes, mostrar }) => {
    const [state, setState] = useState({
        titulo: '',
        data: [],
        header: []
    })
    useEffect(() => {
       
        setState({
            ...state,
            data: data,
            header: [
                'LINEA',
                `${GetMonthNameByNumber(mes)} ${ejercicio}`,
                `${GetMonthNameByNumber(mes)} ${ejercicio - 1}`,
            ]
        })

    }, [])
    const handdleclose = () => {
        const element = document.getElementById('grafica-rotacion-inventario');
        if (element === undefined || element === null) return;
        reactDom.unmountComponentAtNode(element)
    }
    return (
        <div id='rotacion-modal-grafica'>
            <div className='rotacion-grafica'>
                {/* <header>
                    <div className='titulo'>{state.titulo}</div>
                    <div className='close' onClick={handdleclose} >x</div>
                </header> */}
                <div className='container'>
                    {mostrar === 'S' ? <Sucursal
                        encabezado={state.header}
                        data={state.data}
                    />
                        : mostrar === 'R' ? <Region
                            encabezado={state.header}
                            data={state.data}
                        />
                            : <Consolidado
                                encabezado={state.header}
                                data={state.data}
                            />}
                </div>
            </div>
        </div>
    )
}
